import api from '@pray/shared/utils/api';

export type PrayTvContentSlot = {
  id: string;
  published_at: string;
  sunset_at: string;
};

export async function getPrayTvContentSlots({ artistId, contentId }: { artistId: string; contentId: string }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/pray-tv-schedule`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
